import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const SidebarLinkWrapper = styled(Box)`
    display: flex;
    justify-content: space-between;
`;

export const NavButton = styled.button`
    display: block;
    width: 100%;
    text-align: left;
    align-items: center;
    background: transparent;
    cursor: pointer;
    position: relative;
    border-radius: 8px;

    p {
        display: flex;
        align-items: center;
    }
`;
